import {StyleSheet} from "aphrodite";

import {addStyle} from "@khanacademy/wonder-blocks-core";
import {border, semanticColor} from "@khanacademy/wonder-blocks-tokens";

const StyledHr = addStyle("hr");

export default function HorizontalRulePageBreak() {
    return <StyledHr style={styles.hr} />;
}

const styles = StyleSheet.create({
    hr: {
        margin: 0,
        border: "none",
        background: "none",
        boxShadow: "none",
        borderBlockStart: `${border.width.thin} solid ${semanticColor.core.border.neutral.subtle}`,
        "@media print": {
            display: "none",
            pageBreakAfter: "always",
        },
    },
});
